<div class="relative flex flex-col justify-between flex-grow gap-4">
  <div *ngIf="!showComponent" class="absolute flex items-center justify-center w-full h-full bg-white">
    <app-loading-indicator [size]="32"></app-loading-indicator>
  </div>
  <div class="grid grid-cols-2 gap-4">
    <label for="comment-period-status" class="font-normal"
      >Comment Period Status: &nbsp;&nbsp;
      <app-public-commenting-status-badge
        id="comment-period-status"
        [pcmsDraftStatus]="pcmsDraftStatus"
      ></app-public-commenting-status-badge
    ></label>
    <div class="flex flex-col">
      <label class="font-normal" for="comment-period-status-start">
        Commenting Start Date:
        <span id="comment-period-status-start">{{
          commentingStartDate | dateFormat
        }}</span>
      </label>
      <label class="font-normal" for="comment-period-status-end">
        Commenting Finish Date:
        <span id="comment-period-status-end">{{
          commentingEndDate | dateFormat
        }}</span>
      </label>
    </div>
  </div>

  <div class="grid flex-grow grid-cols-2 gap-4 py-4 border-b border-gray-200">
    <div class="flex flex-grow max-h-64" id="div-pcms-pieChart">
      <canvas id="chart-public-commenting" #chartpubliccommenting></canvas>
    </div>

    <div class="flex flex-col justify-center pr-4" id="div-pcms-legend">
      <div class="flex flex-row items-center justify-between py-4 border-b border-gray-200">
        <label class="flex body-default-regular">
          <span [style.color]="editorialColour" class="projectLegend">&#9632;</span>
          <span class="pl-2 mt-1">Editorial</span>
        </label>
        <label>{{ editorialCount }}</label>
      </div>
      <div class="flex flex-row justify-between py-4 border-b border-gray-200">
        <label class="flex body-default-regular">
          <span [style.color]="generalColour" class="projectLegend">&#9632;</span>
          <span class="pl-2 mt-1">General</span>
        </label>
        <label>{{ generalCount }}</label>
      </div>
      <div class="flex flex-row items-center justify-between py-4">
        <label class="flex body-default-regular" >
          <span [style.color]="technicalColour" class="projectLegend">&#9632;</span>
          <span class="pl-2 mt-1">Technical</span>
        </label>
        <label >{{ technicalCount }}</label>
      </div>
    </div>
  </div>

  <div class="flex flex-row">
   <button
      id="a-view-in-public-commenting"
      [disabled]="!isViewPublicCommentingButtonVisible || !commentUrl"
      class="btn btn-primary"
      (click)="openPublicCommenting()"
    >
      View in Public Comment
   </button>
  </div>
</div>
